import { useContext } from 'react';
import { i18n } from '@lingui/core';
import { Select, Stack } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons';
import { ContactContext } from '../Service/Context/ContactContext';
import BookitupTextInput from '../Atoms/inputs/BookitupTextInput';
import { DataS } from '../Service/DataS';
import PanePaper from './PanePaper';

const ContactForm = () => {
  const { contact, saveContactChange } = useContext<any>(ContactContext);
  const { addressStreetAndNo, zipCode, city, phoneNumber, country } = contact;

  return (
    <PanePaper title="common.settings.address">
      <Stack spacing="xs">
        <BookitupTextInput
          label={i18n._('contact.streetAndNo')}
          defaultValue={addressStreetAndNo}
          onBlurSave={(val) => saveContactChange({ addressStreetAndNo: val })}
        />
        <BookitupTextInput
          label={i18n._('contact.zipCode')}
          defaultValue={zipCode}
          onBlurSave={(val) => saveContactChange({ zipCode: val })}
        />
        <BookitupTextInput
          label={i18n._('contact.city')}
          defaultValue={city}
          onBlurSave={(val) => saveContactChange({ city: val })}
        />
        <Select
          searchable
          defaultValue={country}
          data={DataS.countryOptions}
          label="Land"
          styles={{ rightSection: { pointerEvents: 'none' } }}
          rightSection={<IconChevronDown size={14} />}
          onChange={(val) => saveContactChange({ country: val })}
          rightSectionWidth={25}
        />
        <BookitupTextInput
          label={i18n._('contact.phoneNumber')}
          defaultValue={phoneNumber}
          onBlurSave={(val) => saveContactChange({ phoneNumber: val })}
        />
      </Stack>
    </PanePaper>
  );
};

export default ContactForm;
